export default function getStorageSizes(storage) {
  let sizes = {};
  for (let key in storage) {
    if (storage.hasOwnProperty(key)) {
      sizes[key] = storage[key].length;
    }
  }
  return sizes;
}
